import React, { useEffect, useCallback, useState } from "react";
import  {
  FlyToInterpolator,
  StaticMap,
} from "react-map-gl";
import DeckGL from "@deck.gl/react";
import { data } from "../data/mapdata";
import { easeBackInOut } from "d3";

import { ScatterplotLayer } from "@deck.gl/layers";
import { MapView } from "@deck.gl/core";


const VIEWS = [
  new MapView({
    id: "base-map",
    width: "100%",
    //clear: true,
    controller: true,
  }),
];

const INITIAL_VIEW_STATE = {
  latitude: 36.3489,
  longitude: 43.1577,
  zoom: 12,
  maxZoom: 16,
  pitch: 0,
  bearing: 0,
  debug: true,
  zindex: 10,
};


export default function Map(props) {
  const currentSlide = props.currentSlide;
  if (!currentSlide.map) {
    return null;
  }

  //("Map is running.."); // in each side
  const LAYERS_DATA = props.layers;
  //console.log (data)
  
  const layers = new ScatterplotLayer ({
    id: "ScatterPlot",
    data,
    radiusScale: 1,
    getPosition: d => d.coordinates,
    getRadius: (d) => currentSlide.index == 10 ? 5000 :(d.slideNum >currentSlide.index ? 5000:(currentSlide.index==12 ? 100:0)),
    getFillColor:  d => d.color,
    getLineColor: d => d.linecolor,
    lineWidthMinPixels: 1,
    opacity: 0.5,
    filled: true,
    stroked: true,
    updateTriggers: {
      getRadius: [currentSlide.index],
    },
    transitions: {
      getRadius: {
        duration: 200,
        easing: easeBackInOut,
        type: "spring",
        stiffness: 0.05,
        damping: 0.5,
      }},
  })

  return (
    <div
    id={"map-layers"}
    style={{
      position: "fixed",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: props.map,
      flexDirection: "column",
      opacity: currentSlide.map ? "1" : "0",
      backgroundColor: "black", // "black", 7dffb3  00ff7f
      pointerEvents: "none",
      // zIndex: 20,
      width: "100%",
      height: "100%",
      overflow: "hidden",
      // padding: "0vw 10vw",
    }}
    // className={`scrollable-video__container`}
  >
    <DeckGL
      initialViewState={props.viewState}
      controller={true}
      layers={layers}
      >
      <MapView >
        <StaticMap
          mapboxApiAccessToken={props.MAPBOX_TOKEN}
          mapStyle={props.mapStyle}
        />
      </MapView>
    </DeckGL>
  </div>
  );
}





